// react
import { useEffect, useMemo } from 'react';

function useCountryRegion({
  country,
  state,
  countryFieldName,
  stateFieldName,
  getChildSubdivisionMatchingCountryAndState,
  setStatesFromCountry,
  getValues,
  setValue,
}) {
  const states = useMemo(() => {
    if (!country) return [];

    return getChildSubdivisionMatchingCountryAndState(country, state) || [];
  }, [country, state, getChildSubdivisionMatchingCountryAndState]);

  useEffect(() => {
    if (!country) return;

    setStatesFromCountry((prevStates) => {
      if (
        !prevStates ||
        prevStates.length !== states.length ||
        prevStates.some((p, i) => p.code !== states[i]?.code)
      ) {
        return states;
      }
      return prevStates;
    });

    if (states.length && states[0]?.code === 'n/a') {
      setValue(stateFieldName, 'n/a', { shouldValidate: true });
    }

    // Only set country if it differs from current form state
    if (getValues(countryFieldName) !== country) {
      setValue(countryFieldName, country, { shouldValidate: true });
    }
  }, [
    country,
    stateFieldName,
    countryFieldName,
    setStatesFromCountry,
    setValue,
    getValues,
    states,
  ]);
}

export default useCountryRegion;
